import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import authImg from "../../assets/images/auth/main.png";
import useWindowSize from "../../hooks/useWindowSize";
import { useAuth } from "../../hooks/useAuth";
import { IconButton, Menu, MenuItem } from "@mui/material";
import langIcon from "../../assets/images/header-footer/language.png";
import i18n from "../../localization/LocalesConfig";

const AuthLayout = (props) => {
  const { currentLang } = useAuth();
  const direction = currentLang === "en" ? "ltr" : "rtl";
  const { width } = useWindowSize();
  const { updateCurrentLang } = useAuth();
  const [langEl, setLangEl] = useState(null);

  const languages = [
    {
      label: "English",
      lang: "en",
    },
    {
      label: "العربية",
      lang: "ar",
    },
  ];

  const handleLangMenuOpen = (event) => {
    if (event.currentTarget) {
      setLangEl(event.currentTarget);
    }
  };

  const handleChangeLanguage = (lang) => {
    setLangEl(null);
    sessionStorage.setItem("preferredLanguage", lang);
    sessionStorage.setItem("direction", lang === "en" ? "ltr" : "rtl");
    i18n?.changeLanguage(lang);
    updateCurrentLang(lang);
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        background: "linear-gradient(to right, #093AED14, #01D7EB14)",
      }}
      dir={direction}
    >
      <Grid item size={{ xl: 7, lg: 7, md: 6, sm: 12, xs: 12 }}>
        <>
          <IconButton sx={{ color: "#000" }} onClick={handleLangMenuOpen}>
            <img
              src={langIcon}
              alt="language"
              width={width > 600 ? 50 : 30}
              height={width > 600 ? 50 : 30}
            />
          </IconButton>
          <Menu
            anchorEl={langEl}
            open={Boolean(langEl)}
            onClose={() => setLangEl(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
              sx: {
                width: "100px",
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
              },
            }}
          >
            {languages && languages?.length > 0 ? (
              languages?.map((item, index) => (
                <MenuItem
                  key={index}
                  onClick={() => handleChangeLanguage(item.lang)}
                  style={{
                    color: "#004D8A",
                    fontFamily: "Tajawal-Bold",
                    cursor: "pointer",
                  }}
                >
                  {item.label}
                </MenuItem>
              ))
            ) : (
              <MenuItem style={{ textAlign: "center" }}>No Languages</MenuItem>
            )}
          </Menu>
        </>
        {props?.children}
      </Grid>
      {width > 900 && (
        <Grid item size={{ xl: 5, lg: 5, md: 6, sm: 12, xs: 12 }}>
          <img
            src={authImg}
            alt="auth"
            style={{ width: "100%", height: "99vh" }}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default AuthLayout;